import { ProductsMessageKey } from '@retail/products/i18n';
import {
  DocumentationInsight,
  DocumentationFilter,
  EnvironmentInsight,
  EnvironmentFilter,
  PictureInsight,
  PictureFilter,
} from '@retail/products/types';

export type DocumentationDataKey = keyof DocumentationInsight;
export type DocumentationFilterDataKey = keyof DocumentationFilter;
export type EnvironmentDataKey = keyof EnvironmentInsight;
export type EnvironmentDataFilterKey = keyof EnvironmentFilter;
export type PictureDataKey = keyof PictureInsight;
export type PictureFilterDataKey = keyof PictureFilter;

export const documentationTextMap: Record<DocumentationDataKey, ProductsMessageKey> = {
  safetyDataSheet: 'products.mgItem.documentation.sds',
  productDataSheet: 'products.mgItem.documentation.productDataSheet',
  userManual: 'products.mgItem.documentation.userManualUrl',
  explodedView: 'products.mgItem.documentation.explodedViewImageUrl',
  productCatalog: 'products.mgItem.documentation.productCatalog',
  performanceDeclaration: 'products.mgItem.documentation.declarationOfPerformanceUrl',
  installationInstructions: 'products.mgItem.documentation.installationInstructions',
  environmentProductDeclaration: 'products.mgItem.documentation.epd',
  constructionProductDeclaration: 'products.mgItem.documentation.constructionProductDeclaration',
  certificate: 'products.mgItem.documentation.certificate',
  operationAndMaintenance: 'products.mgItem.documentation.operationAndMaintenance',
  disassemblyInstructions: 'products.mgItem.documentation.disassemblyInstructions',
};

export const environmentDataTextMap: Record<EnvironmentDataKey, ProductsMessageKey> = {
  euEcoLabel: 'products.mgItem.environmentDocumentation.ecoLabeled',
  svanen: 'products.mgItem.environmentDocumentation.svaneMarked',
  euBlomman: 'products.mgItem.environmentDocumentation.euBlomman',
  sundahusAssessment: 'products.mgItem.environmentDocumentation.sundahusAssessment',
  blueAngel: 'products.mgItem.environmentDocumentation.blueAngel',
  braMiljoval: 'products.mgItem.environmentDocumentation.goodEnvironmentalChoiceMarked',
  fscCertified: 'products.mgItem.environmentDocumentation.fscCertified',
  pefcCertified: 'products.mgItem.environmentDocumentation.pefcCertified',
  bvb: 'products.mgItem.environmentDocumentation.bvb',
  bastaBeta: 'products.mgItem.environmentDocumentation.betaRegisteredInBasta',
  basta: 'products.mgItem.environmentDocumentation.bastaRegistered',
  bastaDeklarerad: 'products.mgItem.environmentDocumentation.bastaDeklarerad',
  ebvd: 'products.mgItem.environmentDocumentation.ebvd',
};

export const pictureValueTextMap: Record<PictureDataKey, ProductsMessageKey> = {
  productImageSingle: 'products.mgItem.pictureData.productImageSingle',
  inContextProductImage: 'products.mgItem.pictureData.inContextProductImage',
  productInActionImage: 'products.mgItem.pictureData.productInActionImage',
  productImageGroup: 'products.mgItem.pictureData.productImageGroup',
  brandLogo: 'products.mgItem.pictureData.brandLogo',
  lineDrawing: 'products.mgItem.pictureData.lineDrawing',
  colorSampleImage: 'products.mgItem.pictureData.colorSampleImage',
  productSurfaceImage: 'products.mgItem.pictureData.productSurfaceImage',
};

export const environmentFilterDataTextMap: Record<EnvironmentDataFilterKey, ProductsMessageKey> = {
  svanen: 'products.mgItem.environmentDocumentation.svaneMarked',
  euBlomman: 'products.mgItem.environmentDocumentation.euBlomman',
  sundahusAssessment: 'products.mgItem.environmentDocumentation.sundahusAssessment',
  blueAngel: 'products.mgItem.environmentDocumentation.blueAngel',
  bvb: 'products.mgItem.environmentDocumentation.bvb',
  basta: 'products.mgItem.environmentDocumentation.bastaRegistered',
};
